import { Api } from 'models/services/api';
import { ReadDishCategoriesQuery } from 'models/services/graphql';

import { DishCategoryCollectionData } from '../collection';

type DataToRead = {
  menuCategoryId: string
  nextToken?: string;
};

const RequestQuery = `
  query ReadDishCategories($menuCategoryId: ID!, $nextToken: String) {
    ${ReadDishCategoriesQuery}
  }
`;

type ResponseData = {
  data: {
    readDishCategories: DishCategoryCollectionData;
  }
}

class ReadCollectionGql {

  readonly result?: DishCategoryCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToRead): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readDishCategories;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionGql };